/* Clavia Projector Room Planner — UI (ported from mockup V26, 2026-09-17).
   Needs assets/clavia-planner.js (window.ClaviaPlanner) loaded first.
   One instance per .cpp root; data comes from the two JSON script tags the section prints. */
(function () {
  'use strict';

  function init(root) {
    if (root.__cppReady || !window.ClaviaPlanner) return;
    root.__cppReady = true;
    var P = window.ClaviaPlanner;
    var sid = root.getAttribute('data-section');
    var CFG = JSON.parse(document.getElementById('cpp-cfg-' + sid).textContent);
    var D = JSON.parse(document.getElementById('cpp-data-' + sid).textContent);
    /* Shopify's t filter HTML-escapes plain keys (' → &#39;); decode before using as text */
    var ta = document.createElement('textarea');
    (function unesc(o) { Object.keys(o).forEach(function (k) { if (typeof o[k] === 'string') { ta.innerHTML = o[k]; o[k] = ta.value; } else if (o[k] && typeof o[k] === 'object') unesc(o[k]); }); })(D.t);
    var T = D.t, lang = D.lang === 'fr' ? 'fr' : 'en';
    CFG.text = { reason: T.reason, advice: T.advice, decimal: lang === 'fr' ? ',' : null };

    var q = function (k) { return root.querySelector('[data-cpp="' + k + '"]'); };
    var state = { unit: 'm', light: 'curtains', placement: 'shelf', use: 'sports' };   /* Sports first (Larry, Sep 24) */
    var dist = q('dist'), range = q('range'), wall = q('wall'), svg = q('svg');

    var dec = function (s) { return lang === 'fr' ? String(s).replace('.', ',') : String(s); };
    var num = function (el) { return parseFloat(String(el.value).replace(',', '.')); };

    function priceHtml(p) {
      // p.price is money_without_currency, e.g. "699.99" or "1,980.00"
      var s = String(p.price || '').trim();
      var cents = s.slice(-2), sep = s.slice(-3, -2), whole = s.slice(0, -3);
      // follow the store money format (same as the PDP): symbol before or after the amount
      var symFirst = !/^[0-9]/.test(String(p.money || '').trim());
      var h = symFirst
        ? '<sup>$</sup><span>' + whole + '</span><sup>' + sep + cents + '</sup>'
        : '<span>' + whole + '</span><sup>' + sep + cents + '</sup><sup>&nbsp;$</sup>';
      if (p.compare) h += '<s>' + p.compare + '</s>';
      return h;
    }

    function readDistance() {
      var v = num(dist);
      if (isNaN(v) || v <= 0) v = state.unit === 'ft' ? 8.7 : 2.66;
      return state.unit === 'ft' ? P.toMetres(v) : v;
    }
    function readWall() {
      var v = num(wall);
      if (isNaN(v) || v <= 0) return null;
      return state.unit === 'ft' ? P.toMetres(v) : v;
    }
    function dims(r) {
      if (state.unit === 'ft') {
        var w = Math.round(r.pick.width_cm / 2.54), h = Math.round(r.pick.height_cm / 2.54);
        return { w: w, h: h, u: T.inch_unit, txt: w + ' × ' + h + ' ' + T.inch_unit };
      }
      return { w: r.pick.width_cm, h: r.pick.height_cm, u: 'cm', txt: r.pick.width_cm + ' × ' + r.pick.height_cm + ' cm' };
    }

    function drawRoom(r) {
      var W = 640, phone = window.innerWidth < 640, H = phone ? 400 : 620;
      var vw = (svg.getBoundingClientRect().width || 330) / W;
      var fs = phone ? 2.25 : 13 / (11 * vw);
      var d = dims(r);
      var label = String(d.h + ' ' + d.u).length;
      var M = phone ? Math.ceil(8 + label * 11 * fs * 0.55) : Math.ceil(14 + label * 11 * fs * 0.56);
      var wall_m = r.inputs.wall_w_m || (r.pick.width_cm / 100) * (phone ? 1.02 : 1.03);
      var h_m = r.pick.height_cm / 100, w_m = r.pick.width_cm / 100;
      var scale = Math.min((W - 2 * M) / wall_m, (H - 44) / (h_m * 1.14));
      var pw = w_m * scale, ph = h_m * scale, ww = wall_m * scale;
      var wallH = Math.min(H - 30, ph * 1.14);
      var wx = (W - ww) / 2, y = 20 + (wallH - ph) / 2, px = wx + (ww - pw) / 2;
      var font = 'font-family="Figtree,Inter,sans-serif"';
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + Math.ceil(20 + wallH + 8));
      svg.innerHTML =
        '<rect x="' + wx + '" y="20" width="' + ww + '" height="' + wallH + '" fill="#f5f8fc" stroke="#e4e8ee"/>' +
        '<rect x="' + wx + '" y="' + (20 + wallH) + '" width="' + ww + '" height="5" fill="#e4e8ee"/>' +
        '<rect x="' + px + '" y="' + y + '" width="' + pw + '" height="' + ph + '" fill="#19273e"/>' +
        '<rect x="' + (px + 3) + '" y="' + (y + 3) + '" width="' + (pw - 6) + '" height="' + (ph - 6) + '" fill="none" stroke="#4fe0c4" stroke-width="1.5"/>' +
        '<text x="' + (px + pw / 2) + '" y="' + (y - 6) + '" fill="#5e6d85" font-size="' + (11 * fs) + '" text-anchor="middle" ' + font + '>' + d.w + ' ' + d.u + '</text>' +
        '<text x="' + (wx + ww + 6) + '" y="' + (y + ph / 2 + 11 * fs * 0.36) + '" fill="#5e6d85" font-size="' + (11 * fs) + '" ' + font + '>' + d.h + ' ' + d.u + '</text>';
      placeLoop(r, px, y, pw, ph, W);
    }

    /* Video loop + size label laid exactly on the picture rectangle (CSS px). Sep 24 2026 */
    var vid = q('vid'), vlbl = q('vlbl'), vtag = q('vtag'), loopKey = 'sports';
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vidInView = true;
    if (vid) vid.muted = true;
    if (vid && still) { vid.removeAttribute('autoplay'); vid.pause(); }
    function playLoop() { if (!vid || still || !vidInView) return; var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
    /* Phone blocked autoplay (iPhone Low Power Mode, Data Saver)? Retry on the first touch or key: a gesture may start a muted video. The poster frame shows until then. */
    if (vid && !still) {
      var kick = function () { if (vid.paused) playLoop(); }, kickEvs = ['touchstart', 'pointerdown', 'keydown'];
      kickEvs.forEach(function (ev) { document.addEventListener(ev, kick, { passive: true }); });
      vid.addEventListener('playing', function () { kickEvs.forEach(function (ev) { document.removeEventListener(ev, kick); }); }, { once: true });
    }
    function setLoop(k) {
      if (!vid || !D.loops || !D.loops[k] || k === loopKey) return;
      loopKey = k; vid.classList.add('is-swap');
      setTimeout(function () {
        var L = D.loops[k], ss = vid.querySelectorAll('source');
        if (L.poster) vid.poster = L.poster;
        if (ss[0]) ss[0].src = L.mp4; if (ss[1]) ss[1].src = L.webm;   /* MP4 first, same order as the snippet */
        vid.load(); playLoop(); vid.classList.remove('is-swap');
      }, 200);
    }
    function placeLoop(r, px, y, pw, ph, W) {
      if (!vlbl) return;
      var k = (svg.getBoundingClientRect().width || 0) / W;
      var box = { left: px * k, top: y * k, width: pw * k, height: ph * k };
      [vid, vlbl].forEach(function (el) { if (!el) return; el.style.left = box.left + 'px'; el.style.top = box.top + 'px'; el.style.width = box.width + 'px'; el.style.height = box.height + 'px'; });
      vlbl.style.fontSize = Math.max(14, Math.min(64, box.height * 0.34)) + 'px';
      vlbl.textContent = r.pick.diag_in + T.inch_mark;
      if (vtag) {
        var on = root.querySelector('.cpp-rows[data-k="use"] .cpp-row.on b');
        vtag.textContent = on ? on.textContent : '';
        vtag.style.left = (box.left + 6) + 'px'; vtag.style.top = (box.top + 6) + 'px';
        vtag.style.display = box.width < 200 ? 'none' : '';
      }
      setLoop(state.use);
    }
    if (vid && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { vidInView = e.isIntersecting; if (vidInView) playLoop(); else vid.pause(); }); }, { threshold: 0.1 }).observe(vid);
    }

    var last = null;
    /* the screen size the print link was built for, so a changed size can retire it */
    var sentDiag = null;
    function clearSent() {
      var sf = q('save'); if (!sf || !sf.classList.contains('is-sent')) return;
      sf.classList.remove('is-sent');
      var sb = sf.querySelector('.cpp-btn'); if (sb) sb.removeAttribute('aria-disabled');
      q('msg').textContent = '';          /* the email input keeps its value on purpose */
      sentDiag = null;
    }
    function render() {
      var inputs = { distance_m: readDistance(), wall_w_m: readWall(), light: state.light, placement: state.placement, use: state.use, lang: lang };
      var r = P.result(inputs, CFG);
      last = r;
      if (sentDiag !== null && r.pick.diag_in !== sentDiag) clearSent();  /* safety net */
      q('size').textContent = dims(r).txt;
      q('distout').textContent = state.unit === 'ft' ? dec(P.toFeet(inputs.distance_m)) + ' ' + T.unit_ft : dec(inputs.distance_m.toFixed(2)) + ' m';
      var lead = r.pick.capped_by || r.pick.too_small;
      q('warn').textContent = lead ? (r.advice[0] || '') : '';

      var key = r.pick.key, p = D.products[key] || {};
      q('pimg').src = p.image || '';
      q('pimg').alt = T.names[key];
      q('pname').textContent = T.names[key];
      q('pspec').textContent = T.spec[key];
      q('pprice').innerHTML = p.found ? priceHtml(p) : '';
      q('pprice').classList.toggle('has-cmp', !!(p.found && p.compare));
      q('avail').textContent = T[p.stock] || '';
      q('variant').value = p.variant || '';
      q('cta').disabled = !p.found || p.stock === 'sold_out';

      var box = q('alt');
      if (r.alt && D.products[r.alt.key] && D.products[r.alt.key].found) {
        var a = D.products[r.alt.key];
        box.hidden = false;
        q('aimg').src = a.image || '';
        q('aimg').alt = T.names[r.alt.key];
        q('aname').textContent = T.names[r.alt.key];
        q('aprice').textContent = a.money;
        q('ahint').textContent = T.hint[r.alt.key];
        q('alink').href = a.url;
      } else {
        box.hidden = true;
      }

      q('reason').textContent = r.reason;
      var adv = r.advice.slice(lead ? 1 : 0), ul = q('advice');
      ul.innerHTML = '';
      adv.forEach(function (t) { var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
      drawRoom(r);
    }

    /* choices */
    root.querySelectorAll('.cpp-rows').forEach(function (g) {
      var rows = g.querySelectorAll('.cpp-row');
      rows.forEach(function (b) {
        b.setAttribute('aria-checked', b.classList.contains('on') ? 'true' : 'false');
        b.addEventListener('click', function () {
          rows.forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-checked', 'false'); });
          b.classList.add('on'); b.setAttribute('aria-checked', 'true');
          state[g.getAttribute('data-k')] = b.getAttribute('data-v');
          render();
        });
      });
    });

    /* units (both unit toggles move together) */
    var unitBtns = root.querySelectorAll('.cpp-u button');
    unitBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var nu = b.getAttribute('data-u');
        if (nu === state.unit) return;
        var dv = num(dist), wv = num(wall);
        clearSent();
        state.unit = nu;
        unitBtns.forEach(function (x) { var on = x.getAttribute('data-u') === nu; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on); });
        if (!isNaN(dv)) dist.value = nu === 'ft' ? P.toFeet(dv) : P.toMetres(dv);
        if (!isNaN(wv)) wall.value = nu === 'ft' ? P.toFeet(wv) : P.toMetres(wv);
        if (nu === 'ft') { range.min = 2.6; range.max = 19.7; range.step = 0.1; dist.step = 0.1; }
        else { range.min = 0.8; range.max = 6; range.step = 0.05; dist.step = 0.05; }
        range.value = dist.value;
        render();
      });
    });
    dist.addEventListener('input', function () { range.value = dist.value; clearSent(); render(); });
    range.addEventListener('input', function () { dist.value = range.value; clearSent(); render(); });
    wall.addEventListener('input', function () { clearSent(); render(); });

    /* add to cart: the form is a normal /cart/add form, so the Clavia cart drawer
       intercepts it (drawer on desktop, /cart on phones). Without JS it still posts. */
    var form = q('form');
    form.addEventListener('submit', function () {
      var btn = q('cta');
      btn.textContent = T.adding;
      setTimeout(function () { btn.textContent = T.add; }, 2500);
    });

    /* save form: validate, show the markers link, and log the Klaviyo event that triggers the email */
    q('save').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = this.querySelector('input[type=email]'), msg = q('msg');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim())) { msg.textContent = T.save_invalid; input.focus(); return; }
      var r = last, href = D.markersUrl + '?d=' + (r ? r.pick.diag_in : 100);
      msg.innerHTML = '';
      msg.appendChild(document.createTextNode(T.save_done + ' '));
      var a = document.createElement('a');
      a.href = href; a.target = '_blank'; a.rel = 'noopener'; a.className = 'cpp-print'; a.textContent = T.save_print;
      msg.appendChild(a);
      this.classList.add('is-sent');
      sentDiag = r ? r.pick.diag_in : null;
      var sb = this.querySelector('.cpp-btn'); if (sb) sb.setAttribute('aria-disabled', 'true');
      sendPlan(input.value.trim(), r);
      /* Shopify Customers: record this email with source "room-planner" (no marketing
         subscription). Independent of Klaviyo; off when the capture URL setting is blank. */
      if (window.ClaviaCapture) {
        ClaviaCapture.send('room-planner', input.value.trim(), r ? { projector_key: r.pick.key, diagonal_in: r.pick.diag_in } : null);
      }
    });

    /* Klaviyo: log a transactional "Saved Room Plan" event so a flow can email the plan.

       Generate on demand, host nothing. The email carries markers_url; the markers page
       redraws the five sheets in the browser from the diagonal in that link every time it
       is opened. There is no file to store, so the link never expires and costs nothing.
       plan_url reopens this planner with the visitor's own answers restored.

       Every measurement below is metric, because that is what the markers page prints.
       unit only records which way the visitor was reading the planner.

       Transactional only - the profile is created but never subscribed to a marketing
       list, so this needs no marketing consent.
       Fire and forget: the confirmation and the print link are already on screen, and a
       failed log must not break what the visitor is waiting for. */
    function sendPlan(email, r) {
      if (!window.ClaviaKlaviyo || !email || !r) return;
      var m = r.pick;
      var abs = function (u) { return u && u.indexOf('http') === 0 ? u : (D.shopUrl || '') + (u || ''); };
      var distM = Math.round((r.inputs.distance_m || 0) * 100) / 100;

      /* The deep link carries the two numbers exactly as the visitor typed them, in the
         unit that was on screen, because the planner writes them straight back into those
         fields on the way in. Converting to metres here lands a metre value in a foot
         field, which silently turns a 13 ft room into a 4 ft one. */
      var back = new URLSearchParams();
      back.set('d', dist.value);
      if (wall.value) back.set('w', wall.value);
      back.set('unit', state.unit);
      back.set('light', state.light);
      back.set('placement', state.placement);
      back.set('use', state.use);

      ClaviaKlaviyo.track('Saved Room Plan', {
        /* ready to drop straight into the email body */
        picture_size: m.diag_in + '\u2033 \u00b7 ' + m.width_cm + ' \u00d7 ' + m.height_cm + ' cm',
        markers_url: abs(D.markersUrl + '?d=' + m.diag_in),
        plan_url: location.origin + location.pathname + '?' + back.toString(),
        projector: (T.names && T.names[m.key]) || m.key,
        /* raw values, for segmentation and for anything the template wants to recompose */
        diagonal_in: m.diag_in,
        picture_w_cm: m.width_cm,
        picture_h_cm: m.height_cm,
        distance_m: distM,
        wall_w_m: r.inputs.wall_w_m || null,
        projector_key: m.key,
        light_test_url: D.lightTestUrl || '',
        setup_guide_url: D.setupGuideUrl || '',
        room_light: state.light,
        placement: state.placement,
        watching: state.use,
        unit: state.unit,
        locale: lang,
        source: 'Projector Room Planner'
      }, { email: email }, { keepalive: true });
    }

    /* deep link: ?d=2.66&w=3&unit=ft&light=curtains&placement=shelf&use=movies */
    var qs = new URLSearchParams(location.search);
    if (qs.get('unit') === 'ft') root.querySelector('.cpp-u button[data-u="ft"]').click();
    if (qs.get('d')) { dist.value = qs.get('d'); range.value = qs.get('d'); }
    if (qs.get('w')) wall.value = qs.get('w');
    ['light', 'placement', 'use'].forEach(function (k) {
      var v = qs.get(k);
      if (v && CFG.inputs[k].indexOf(v) > -1) {
        var b = root.querySelector('.cpp-rows[data-k="' + k + '"] .cpp-row[data-v="' + v + '"]');
        if (b) b.click();
      }
    });

    /* EN title stays on one line: shrink it if the column is too narrow. FR wraps by design. */
    var h1 = root.querySelector('.cpp-h1');
    function fitH1() {
      h1.style.fontSize = '';
      if (lang === 'fr') return;
      var fs = parseFloat(getComputedStyle(h1).fontSize);
      while (h1.scrollWidth > h1.clientWidth && fs > 18) { fs -= 1; h1.style.fontSize = fs + 'px'; }
    }
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { fitH1(); render(); }, 120); });
    fitH1();
    render();
  }

  function boot() { document.querySelectorAll('.cpp[data-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
